import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getProductById } from "../../services/productsService";
import { ProductImages } from "../../components/ProductImages/ProductImages";
import { ProductDetails } from "../../components/ProductDetails/ProductDetails";
import "./Product.css";

export default function Product({ id: propId }) {
  const params = useParams();
  const navigate = useNavigate();
  const id = propId || params.id;
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    getProductById(id)
      .then((data) => {
        setProduct(data.result || data);
        setLoading(false);
      })
      .catch(() => {
        setProduct(null);
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return (
      <div className="product-page-loading">
        <div className="product-page-loading__spinner" />
        <p className="product-page-loading__text">Cargando producto...</p>
      </div>
    );
  }

  return (
    <div className="product-page">

      {/* Breadcrumb */}
      <nav className="product-page__breadcrumb">
        <button onClick={() => navigate("/")}>Inicio</button>
        <span className="product-page__breadcrumb-sep">/</span>
        <button onClick={() => navigate("/shop")}>Catálogo</button>
        <span className="product-page__breadcrumb-sep">/</span>
        <span>{product?.name ?? product?.data?.name ?? "Producto"}</span>
      </nav>

      {/* Contenido principal */}
      <div className="product-page__body">

        {/* Galería */}
        <div className="product-page__gallery">
          <ProductImages productId={id} />
        </div>

        {/* Detalles */}
        <div className="product-page__details">
          <ProductDetails product={product} />
        </div>

      </div>
    </div>
  );
}
